// extracted by mini-css-extract-plugin
export default {"mobile":"Masonry_mobile__9e4aj","web":"Masonry_web__xIiAz","webelement":"Masonry_webelement__vORso"};